import { Injectable } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { IValidacionFormulario } from "./IValidacionFormulario-interface";


@Injectable({
  providedIn: "root",
})
export class ValidacionBeneficiarioService implements IValidacionFormulario {
  validar(form: FormGroup): void {
    const indexUltimoRegistro = this.getIndexUltimoBeneficiario(form);
    const beneficiarios = form.get("pacs");

    if (!beneficiarios || !(beneficiarios instanceof FormArray) || indexUltimoRegistro < 0) return;

    const ultimoBeneficiario = beneficiarios.controls[indexUltimoRegistro];
    if (ultimoBeneficiario instanceof FormGroup) {
      ultimoBeneficiario.get("EsValido")?.setValue(true);
    }
  }

  public getIndexUltimoBeneficiario(form: FormGroup): number {
    const beneficiarios = form.get("pacs");
    return beneficiarios instanceof FormArray ? beneficiarios.length - 1 : -1;
  }
}
